import * as d3 from 'd3';
import {
  VACCINATION_CHARTS_LEFT_PADDING,
  VACCINATION_CHARTS_RIGHT_PADDING,
  HERD_IMMUNITY_PERCENT,
  VACCINATION_CHARTS_BAR_HEIGHT
} from '../constants';
import {scaled} from '../utils';

export default function() {
  // required parameters
  let data;

  // constants
  const padding = [20, VACCINATION_CHARTS_RIGHT_PADDING, 30, VACCINATION_CHARTS_LEFT_PADDING];

  // variables
  let height;

  const chart = function(selection) {
    selection.each(function() {
      height = (data.length * VACCINATION_CHARTS_BAR_HEIGHT) + padding[0] + padding[2];

      const container = d3.select(this);

      container.attr('id', 'percent-vaccinated')
        .attr('class', 'chart');

      const svg = container.append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin meet');

      const xScale = d3.scaleLinear()
        .domain([0, 1])
        .range([0, width - (padding[3] + padding[1])]);

      const yScale = d3.scaleBand()
        .domain(data.map(d => d.country))
        .range([padding[0], height - padding[2]])
        .paddingInner(0.1);

      // value bar
      svg.selectAll('.value-bar')
        .data(data)
        .join('rect')
        .attr('class', d => d.country === 'Ireland' ? 'value-bar value-bar--highlighted' : 'value-bar')
        .attr('x', padding[3])
        .attr('y', d => yScale(d.country))
        .attr('width', d => xScale(d.percentVaccinated))
        .attr('height', yScale.bandwidth());

      // background bar
      svg.selectAll('.bg-bar')
        .data(data)
        .join('rect')
        .attr('class', 'bg-bar')
        .attr('x', d => xScale(d.percentVaccinated) + padding[3])
        .attr('y', d => yScale(d.country))
        .attr('width', d => width - (padding[1] + padding[3] + xScale(d.percentVaccinated)))
        .attr('height', yScale.bandwidth());

      // herd immunity
      const lineX = xScale(HERD_IMMUNITY_PERCENT) + padding[3];
      const lineY2 = (height - padding[2]) + 10;
      svg.append('line')
        .attr('class', 'herd-immunity-line')
        .attr('x1', lineX)
        .attr('y1', padding[0])
        .attr('x2', lineX)
        .attr('y2', lineY2);

      svg.append('text')
        .attr('class', 'herd-immunity-label')
        .attr('x', lineX)
        .attr('y', lineY2 + 15)
        .text(`Herd immunity - ${d3.format('.0%')(HERD_IMMUNITY_PERCENT)}`);

      // value (percent)
      svg.selectAll('.value')
        .data(data)
        .join('text')
        .attr('class', 'value')
        .attr('x', d => xScale(d.percentVaccinated) + padding[3] - 6)
        .attr('y', d => yScale(d.country) + (yScale.bandwidth() / 2))
        .attr('alignment-baseline', 'central')
        .text(d => d3.format('.2%')(d.percentVaccinated));

      // country
      svg.selectAll('.country')
        .data(data)
        .join('text')
        .attr('class', d => d.country === 'Ireland' ? 'country country--highlighted' : 'country')
        .attr('x', padding[3] - 8)
        .attr('y', d => yScale(d.country) + (yScale.bandwidth() / 2))
        .attr('alignment-baseline', 'central')
        .text(d => d.country);
    })
  };

  chart.data = function(_) {
    if (!arguments.length) return data;
    data = _;
    return chart;
  };

  return chart;
}
